var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAssociatedIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 12,
    viewBox: "0 0 14 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.6666 5.33333V0H8.99998V2H4.99998V0H0.333313V5.33333H4.99998V3.33333H6.33331V10H8.99998V12H13.6666V6.66667H8.99998V8.66667H7.66665V3.33333H8.99998V5.33333H13.6666ZM3.66665 4H1.66665V1.33333H3.66665V4ZM10.3333 8H12.3333V10.6667H10.3333V8ZM10.3333 1.33333H12.3333V4H10.3333V1.33333Z",
    fill: "#1F6BEB"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAssociatedIcon);
export default __webpack_public_path__ + "static/media/AssociatedIcon.1d059ca7.svg";
export { ForwardRef as ReactComponent };